

(function() {
  'use strict';
  
  // 活动弹窗管理器
  var ActivityPopupManager = {
    // 配置参数
    config: {
      // 默认配置集中在这里：以后只需要改这一处
      pcFormId: '6ae2b197cfd2c23d306ef540',
      mobileFormId: '6ae2ba01cfd2c23d306ef599',
      mobileBreakpoint: 768
    },
    
    // 初始化管理器
    init: function(options) {
      options = options || {};
      // 合并配置
      this.config = Object.assign({}, this.config, options);
      
      // 验证必要参数
      if (!this.config.pcFormId || !this.config.mobileFormId) {
        return false;
      }
      
      return true;
    },
    
    // 显示PC端弹窗
    showPopupPC: function() {
      if (!this.config.pcFormId) {
        return;
      }
      // this.addiconChristmas()
      // this.addWinter()
      this.addFreeCleaning()
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', this.config.pcFormId]);
    },
    
    // 显示移动端弹窗
    showPopupMobile: function() {
      console.error(this.config.mobileFormId,window.omnisend,'window.omnisend');
      localStorage.setItem('mobileFormId',this.config.mobileFormId);
      localStorage.setItem('pcFormId',this.config.pcFormId);
      localStorage.setItem('omnisend',JSON.stringify(window.omnisend));
      
      if (!this.config.mobileFormId) {
        return;
      }
      // this.addiconChristmas()
      // this.addWinter()
      this.addFreeCleaning()
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', this.config.mobileFormId]);
      setTimeout(() => {
        // this.judgePlugin();
      }, 100);
    },
    
    // 根据设备类型显示对应弹窗
    showPopupByDevice: function() {
      if (window.innerWidth <= this.config.mobileBreakpoint) {
        this.showPopupMobile();
      } else {
        this.showPopupPC();
      }
    },
    
    // 判断插件是否加载 并且在移动端有动画效果
    judgePlugin: function() {
      var attempts = 0;
      //插件会延迟 所以需要轮询 20次 每次1秒
      var maxAttempts = 20;
      var intervalMs = 1000;
      
      function attachIfReady() {
        var pluginIcon = document.querySelector('.omnisend-form-' + ActivityPopupManager.config.mobileFormId + '-close-action');
        if (!pluginIcon) {
          return false;
        }
        
        // 避免重复绑定
        if (pluginIcon.getAttribute('data-intercept-attached') === '1') {
          return true;
        }
        pluginIcon.setAttribute('data-intercept-attached', '1');
        
        var pluginClickInterceptor = function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          
          var pluginContainer = document.querySelector('.omnisend-form-' + ActivityPopupManager.config.mobileFormId + '-content');
          if (pluginContainer) {
            if (pluginContainer.getAttribute('data-animating') === '1') {
              return false;
            }
            
            pluginContainer.setAttribute('data-animating', '1');
            var rect = pluginContainer.getBoundingClientRect();
            var anchorX = window.innerWidth * 0.8 - 30; // 距离右边20%
            var anchorY = window.innerHeight - 20; // 距离底部20px
            var originX = anchorX - rect.left;
            var originY = anchorY - rect.top;
            
            pluginContainer.style.transformOrigin = originX + 'px ' + originY + 'px';
            pluginContainer.style.transition = 'transform 0.6s ease, opacity 0.6s ease';
            pluginContainer.style.willChange = 'transform, opacity';
            pluginContainer.style.transform = 'scale(1)';
            pluginContainer.style.opacity = '1';
            
            void pluginContainer.offsetWidth;
            
            pluginContainer.style.transform = 'scale(0)';
            pluginContainer.style.opacity = '0';
            
            pluginContainer.addEventListener('transitionend', function onEnd(ev) {
              if (ev.propertyName !== 'transform' && ev.propertyName !== 'opacity') return;
              
              pluginContainer.removeEventListener('transitionend', onEnd);
              pluginContainer.removeAttribute('data-animating');
              
              // 清理动画样式，交回给插件自身处理关闭
              pluginContainer.style.transition = '';
              pluginContainer.style.willChange = '';
              
              // 取消拦截并触发一次原始点击
              pluginIcon.removeEventListener('click', pluginClickInterceptor, true);
              pluginIcon.removeAttribute('data-intercept-attached');
              
              try {
                pluginIcon.dispatchEvent(new MouseEvent('click', { 
                  bubbles: true, 
                  cancelable: true 
                }));
              } catch (err) {
                var evt = document.createEvent('MouseEvents');
                evt.initEvent('click', true, true);
                pluginIcon.dispatchEvent(evt);
              }
            }, { once: true });
          }
          return false;
        };
        
        // 捕获阶段拦截，优先于插件自己的冒泡监听器
        pluginIcon.addEventListener('click', pluginClickInterceptor, true);
        return true;
      }

      // 先尝试一次，若未找到则开始轮询
      if (attachIfReady()) {
        return;
      }
      
      var timerId = setInterval(function() {
        attempts++;
        if (attachIfReady() || attempts >= maxAttempts) {
          clearInterval(timerId);
        }
      }, intervalMs);
    },
    // 添加icon或者初始化之后使用js新增各种样式
    // addicon: function() {
    //   let img1 = document.createElement('img');
    //   img1.src = 'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/lQLPJwffSc_uz_PMyMy5sCd49151cHacCOj1wt-C1AE_185_200.png?v=1762505294';
    //   img1.alt = 'icon';
    //   img1.width = 70;
    //   img1.height = 70;
    //   img1.classList.add('icon-img1');
    //   img1.style.position = 'absolute';
    //   img1.style.right = '0';
    //   img1.style.bottom = '0';

    //   let img2 = document.createElement('img');
    //   img2.src = 'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/lQLPJxn0ncnW7_M8PLBJx270RevBBAjo9cLfgtQA_60_60.png?v=1762505294';
    //   img2.alt = 'icon';
    //   img2.style.width = '20px';
    //   img2.style.height = '20px';
    //   img2.style.marginTop = '10px';
    //   img2.classList.add('icon-img2');
      
    //   let img3 = document.createElement('img');
    //   img3.src = 'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/wps_2.gif?v=1762505294';
    //   img3.alt = 'icon';
    //   img3.style.width = '40px';
    //   img3.style.height = '40px';
    //   img3.style.position = 'absolute';
    //   img3.style.right = '15px';
    //   img3.style.bottom = '-10px';
    //   img3.classList.add('icon-img3');

      

    //   let timer=setInterval(()=>{
    //     let form=''
    //     let firstTitle=''
    //     let seeBtn=''
    //     if(window.innerWidth <= 768) {
    //       form = document.querySelector('.omnisend-form-690dde73a4d433ba5d00211d-sections-container');
    //       firstTitle = document.querySelector('.omnisend-form-690dde73a4d433ba5d00211d-text-624ab2f927652f651edfd0b0');
    //       seeBtn = document.querySelector('.omnisend-form-690dde73a4d433ba5d00211d-text-690daaa83968ff77f9bb4695 strong');
    //     }else{
    //       form = document.querySelector('.omnisend-form-690da87eb127c51a5d21ee2e-sections-container');
    //       firstTitle = document.querySelector('.omnisend-form-690da87eb127c51a5d21ee2e-text-624ab2f927652f651edfd0b0');
    //       seeBtn = document.querySelector('.omnisend-form-690da87eb127c51a5d21ee2e-text-690daaa83968ff77f9bb4695 ');
    //     }
    //     if(form||firstTitle||seeBtn) {
    //       clearInterval(timer);
    //       if(!form.querySelector('.icon-img1')) {
    //         form.insertBefore(img1, form.lastChild);
    //       }
    //       if(!form.querySelector('.icon-img2')) {
    //         firstTitle.insertBefore(img2,firstTitle.firstChild);
    //       }
    //       if(!seeBtn.querySelector('.icon-img3')) {
    //         seeBtn.insertBefore(img3, seeBtn.firstChild);
    //         seeBtn.onclick = function() {
    //           window.location.href = 'https://betterlovedoll.com/blogs/all/black-friday-event-officially-begins#section2';
    //         }
    //       }
    //     }
    //   }, 1000);
    // },
    addiconChristmas: function() {
      let timer=setInterval(()=>{
        let img3 = document.createElement('img');
        img3.src = 'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/wps_2.gif?v=1762505294';
        img3.alt = 'icon';
        img3.style.width = '40px';
        img3.style.height = '40px';
        img3.style.position = 'absolute';
        img3.style.right = '-8px';
        img3.style.bottom = '-23px';
        img3.classList.add('christmas-icon');
        let rightBox=''
        let rightBox2=''
        let seeBtn=''
        var formId = (window.innerWidth <= 768) ? ActivityPopupManager.config.mobileFormId : ActivityPopupManager.config.pcFormId;
        if (formId) {
          rightBox=document.querySelector('.omnisend-form-' + formId + '-section-624ab2f927652f651edfd0ac');
          seeBtn=document.querySelector('.omnisend-form-' + formId + '-text-692fa9688b28f0b0023ac78a p');
          rightBox2=document.querySelector('.omnisend-form-' + formId + '-section-62a313b876d81914aa87ed79');
        }
          if(rightBox) {
            clearInterval(timer);
            rightBox.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0733/4078/0844/files/97_02.jpg?v=1764732720)';
            rightBox.style.backgroundSize = '100% 100%';
            rightBox.style.backgroundPosition = 'center center';
            rightBox.style.backgroundRepeat = 'no-repeat';
          }
          if(rightBox2) {
            clearInterval(timer);
            rightBox2.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0733/4078/0844/files/97_02.jpg?v=1764732720)';
            rightBox2.style.backgroundSize = '100% 100%';
            rightBox2.style.backgroundPosition = 'center center';
            rightBox2.style.backgroundRepeat = 'no-repeat';
          }
          if(seeBtn) {
            clearInterval(timer);
            seeBtn.insertBefore(img3, seeBtn.firstChild);
            seeBtn.onclick = function() {
              window.location.href = 'https://betterlovedoll.com/blogs/all/christmas-celebration-warmth-awaits#section1';
            }
          }
      }, 100);
    },
    addWinter: function() {
      let timer=setInterval(()=>{
        let img3 = document.createElement('img');
        img3.src = 'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/wps_2.gif?v=1762505294';
        img3.alt = 'icon';
        img3.style.width = '40px';
        img3.style.height = '40px';
        img3.style.position = 'absolute';
        img3.style.right = '-8px';
        img3.style.bottom = '-23px';
        img3.classList.add('christmas-icon');
        let rightBox=''
        let seeBtn=''
        if (window.innerWidth <= 768) {
          rightBox=document.querySelector('.omnisend-form-695f1cd5a3e847f51a4cb429-section-624ab2f927652f651edfd0ac');
          seeBtn=document.querySelector('.omnisend-form-695f1cd5a3e847f51a4cb429-text-690daaa83968ff77f9bb4695 p strong');
        }else{
          rightBox=document.querySelector('.omnisend-form-695f1cd5a3e847f51a4cb429-section-624ab2f927652f651edfd0ac');
          seeBtn=document.querySelector('.omnisend-form-695f1cd5a3e847f51a4cb429-text-690daaa83968ff77f9bb4695 p strong');
        }
          if(rightBox) {
            clearInterval(timer);
            rightBox.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0733/4078/0844/files/lQDPKHf_T3hV3MfNA0rNApiw4XQ6tjZCPNoJN3KI19IOAA_664_842.jpg?v=1767852007)';
            rightBox.style.backgroundSize = '100% 100%';
            rightBox.style.backgroundPosition = 'center center';
            rightBox.style.backgroundRepeat = 'no-repeat';
          }
          if(seeBtn) {
            clearInterval(timer);
            seeBtn.insertBefore(img3, seeBtn.firstChild);
            seeBtn.onclick = function() {
              window.location.href = 'https://betterlovedoll.com/collections/betterlovedoll-january-event-purchase-select-dolls-and-receive-a-free-heated-robe';
            }
          }
      }, 100);
    },
    addFreeCleaning: function() {
      let timer=setInterval(()=>{
        let img3 = document.createElement('img');
        img3.src = 'https://cdn.shopify.com/s/files/1/0661/6059/1091/files/wps_2.gif?v=1762505294';
        img3.alt = 'icon';
        img3.style.width = '40px';
        img3.style.height = '40px';
        img3.style.position = 'absolute';
        img3.style.right = '28px';
        img3.style.bottom = '0px';
        img3.classList.add('christmas-icon');
        let rightBox=''
        let seeBtn=''
        if (window.innerWidth <= 768) {
          rightBox=document.querySelector('.omnisend-form-69b0e2403950c1359b3aa2b2-section-624ab2f927652f651edfd0ac');
          seeBtn=document.querySelector('.omnisend-form-69b0e2403950c1359b3aa2b2-text-690daaa83968ff77f9bb4695 p strong');
        }else{
          rightBox=document.querySelector('.omnisend-form-69b0e2403950c1359b3aa2b2-sections-container');
          seeBtn=document.querySelector('.omnisend-form-69b0e2403950c1359b3aa2b2-text-690daaa83968ff77f9bb4695 p strong');
        }
          if(rightBox) {
            clearInterval(timer);
            rightBox.style.backgroundImage = 'url(https://cdn.shopify.com/s/files/1/0733/4078/0844/files/5_418ac81c-661a-4529-9038-f5ae56818923.jpg?v=1773716309)';
            rightBox.style.backgroundSize = '100% 100%';
            rightBox.style.backgroundPosition = 'center center';
            rightBox.style.backgroundRepeat = 'no-repeat';
          }
          if(seeBtn) {
            clearInterval(timer);
            seeBtn.insertBefore(img3, seeBtn.firstChild);
            seeBtn.onclick = function() {
              window.location.href = 'https://betterlovedoll.com/collections/march-exclusive-free-cleaning-kit-205-value';
            }
          }
      }, 100);
    },
  };
  
  // 将管理器暴露到全局作用域
  window.ActivityPopupManager = ActivityPopupManager;
  
  // 暴露全局函数，供其他文件调用
  window.showActivePopup = function() {
    ActivityPopupManager.showPopupByDevice();
  };
  
  window.showPopupMobile = function() {
    ActivityPopupManager.showPopupMobile();
  };
  
  window.showPopupPC = function() {
    ActivityPopupManager.showPopupPC();
  };
  
})();
